import { Button, InputCheckbox, InputText } from '@/components/atoms';
import { useEffect, useState } from 'react';
import { MdClose, MdSearch } from 'react-icons/md';

export default function ModalCategory({
  show = false,
  subcategories = null,
  selectedCategory = [],
  onChangeCategory,
  onClose,
  onReset,
}) {
  const [showCategories, setShowCategories] = useState([]);
  const [categories, setCategories] = useState([]);

  const handleChangeCategory = (categoryId, e) => {
    const cat = [...categories];

    if (e.target.checked) {
      cat.push(categoryId.toString());
    } else {
      const findIndex = cat.findIndex((obj) => obj === categoryId.toString());
      if (findIndex !== -1) {
        cat.splice(findIndex, 1);
      }
    }

    setCategories(cat);
  };

  const handleChangeSearch = (e) => {
    const { value } = e.target;
    if (!value) {
      setShowCategories(subcategories);
    }

    const filterCat = subcategories.filter((category) => {
      return category?.name?.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    });

    setShowCategories(filterCat);
  };

  useEffect(() => setShowCategories(subcategories), [subcategories]);
  useEffect(() => {
    const cat = [];
    if (selectedCategory?.length > 0) {
      selectedCategory.forEach((row) => cat.push(row.toString()));
    }
    setCategories(cat);
  }, [selectedCategory]);

  return (
    <>
      {show ? (
        <div
          className="absolute bg-white border border-gray-400 shadow-lg rounded-lg z-20 -left-0"
          style={{ width: '320px' }}
        >
          <div className="flex items-center justify-between mt-4 px-4">
            <div className="font-semibold text-gray-800">Cari Kategori</div>
            <button type="button" onClick={onClose}>
              <MdClose size={22} />
            </button>
          </div>
          <div className="mt-2 pl-4 pr-10">
            <div className="relative">
              <InputText
                type="text"
                placeholder="Search"
                onChange={handleChangeSearch}
                inputClassName="pl-3"
                icon={
                  <div className="absolute left-3">
                    <MdSearch size={24} />
                  </div>
                }
              />
            </div>
          </div>
          <div className="border border-b-400 mb-3 mt-4" />
          <div className="mt-2 px-4">
            {/* Group subcategories by parent category */}
            {Array.from(new Set(showCategories.map((cat) => cat.parentId))).map((parentId) => {
              const parent = showCategories.find((cat) => cat.parentId === parentId);
              const subcats = showCategories.filter((cat) => cat.parentId === parentId);

              return (
                <div key={parentId} className="mb-3">
                  <div className="font-semibold mb-1">{parent?.parentTitle}</div>
                  {subcats.map((category) => (
                    <div className="pb-1 ml-2" key={category.id}>
                      <InputCheckbox
                        id={`category-${category?.name}`}
                        name="category_id"
                        label={category?.name}
                        labelClassName="text-black"
                        checked={categories.includes(category?.id.toString())}
                        onChange={(e) => handleChangeCategory(category?.id, e)}
                      />
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
          <div className="grid grid-cols-2 gap-x-2 m-4">
            <Button size={Button.SIZES.MEDIUM} variant={Button.VARIANTS.GRAY_OUTLINE} onClick={onReset}>
              Reset
            </Button>
            <Button
              size={Button.SIZES.MEDIUM}
              variant={Button.VARIANTS.TERTIARY}
              onClick={() => onChangeCategory(categories.join(','))}
            >
              Terapkan
            </Button>
          </div>
        </div>
      ) : null}
    </>
  );
}
